import { useContext } from "react"
import { LinkContext } from "./LinkContext"

export const useLinkContext = () => {
    const context = useContext(LinkContext)

    if (context === undefined) {
        throw new Error('useLinkContext must be used within a LinkContextProvider')
    }

    return context
}